<!--  -->
<template>
  <div>
    <div class="def-container">
      <div>
        <div class="sbTitle"><h1>企业授权书</h1></div>
        <div style="text-align: right">更新时间：2021-12-09</div>
        <el-divider />
        <div>
          <p>
            &nbsp; &nbsp; &nbsp;
            我公司（单位）知晓【信阳市政策计算器平台】（以下简称"平台"）是信阳市政务服务和大数据管理局（以下简称"平台建设单位"）
            负责建设的全市企业服务平台，依法为全市企业提供统上扶持统一服务.
          </p>
          <p>
            &nbsp; &nbsp; &nbsp;
            一、为确保企业信息的准确性，减少企业申报材料，压缩审批时长，实现政策“免申即享"，我公司（单位）在所申报事项的申报要求
            范围内授权平台及平台建设单位从国家机关、政府部门、企事业单位、金融机肉等相关部门（单位）、行业协会、社会团体、关联企业、互
            联网信息平台等渠道依法采集下列信息（包括历史信息及审新）：
          </p>
          <p>
            &nbsp; &nbsp; &nbsp;
            （1）包括但不限于我公司（单位）的企业基本信息、企业金融信息、企业经营信息、企业负面信息、企业的董事、监事、高级管理人员与
            其履行职务相关的信息等企业向相关部门（单位）提供的和相关部门（单位）在管理工作中产生的信息。
          </p>
          <p>
            &nbsp; &nbsp; &nbsp;
            （2）包括但不限于国家法律、行政法规、部门规直、地方性法规未禁止政府部门采集的、与授权企业有关的其他信息。
          </p>
          <p>
            &nbsp; &nbsp; &nbsp;
            二、我公司（单位）承诺:国家机关、政府部门、事业单位等部门（单位），因行政管理、公共服务、统计分析等法定工作需要，可以直接
            直询上述信息。平台及平台建设单位可以依法向上述部门（单位）提供该信息.
          </p>
          <p>
            &nbsp; &nbsp; &nbsp;
            三、本授权自我公司（单位）签署之日起生效，如需终止本授权，我公司（单位）同意向平台再次提交解除授权通知，经平台及平台建设单
            位审核满足终止授权条件后终止.
          </p>
          <p>
            &nbsp; &nbsp; &nbsp;
            四、我公司（单位）在此声明，已知悉并理解本授权委托书授权内容，已充分理解并同意，属自愿授权。
          </p>
        </div>
        <div class="btnPart">
          <el-button class="disagreeBtn" @click="returnPage">返回</el-button>
          <el-button class="agreeBtn" @click="tonewPage">确认授权</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isstep: 1,
      type: "",
    };
  },

  components: {},

  created() {},

  mounted() {},

  methods: {
    returnPage() {
      this.$router.push('/policyLibrary');
    },
    tonewPage() {
      this.$router.push("/enjoyWithoutApply/viewEnjoyPage");
    },
  },
};
</script>
<style lang='scss' scoped>
.breadcrumbPart {
  padding-top: 2.5rem;
  font-size: 1.25rem;
}
.sbTitle {
  margin: 4rem 0 0.625rem 0;
  text-align: center;
  h1 {
    color: #000;
  }
}
.sbTitle2 {
  margin: 20px auto;
}
p {
  font-size: 16px;
  line-height: 2.1875rem;
  color: #000;
}
.btnPart {
  padding-top: 6.25rem ;
  text-align: center;
}
.disagreeBtn {
  width: 7.5rem;
//   height: 2.5rem;
  border: 1px solid;
  border-color: #dd0000;
  border-radius: unset;
  color: #dd0000;
  background-color: #fff;
  font-size: 1.125rem;
}
.agreeBtn {
  width: 7.5rem;
//   height: 2.5rem;
  background-color: #dd0000;
  border-radius: unset;
  color: #fff;
  font-size: 1.125rem;
  margin-left: 2.5rem;
}
::v-deep {
  .el-divider--horizontal {
    height: 0.125rem;
  }
}
</style>
